import type { AsyncTranslatorArg } from 'components/secondaryMarket/shared/Clipboard/types';
import { getCounterpartFromEliotCode } from 'components/secondaryMarket/shared/components/clientSelectors/ClientSelector';

export function translateEliotCodeIntoSaleCounterpart({
  pastedValue,
  doPasteCallback: doPaste,
  setEditableStateCallback: setEditableState,
  simpleFormatMessage: formatMessage,
  onPasteSuccess,
  onPasteFailure,
}: AsyncTranslatorArg) {
  setEditableState({
    status: 'loading',
  });

  return getCounterpartFromEliotCode(pastedValue as string)
    .then(client => {
      if (client !== null) {
        doPaste(client);
        setEditableState({
          status: 'done',
        });
        onPasteSuccess?.();
      } else {
        setEditableState({
          status: 'failed',
          errors: formatMessage('secondaryMarket.batch.paste.error.eliotCode', { pastedValue }),
        });
        onPasteFailure?.();
      }
    })
    .catch(() => {
      setEditableState({ status: 'failed', errors: formatMessage('secondaryMarket.batch.paste.error') });
      onPasteFailure?.();
    });
}
